<template>
  <el-button v-bind="$attrs" v-on="$listeners" round class="disaprove-button">
    <i class="fas fa-times"></i> Desaprovar
  </el-button>
</template>

<script>
export default {
  name: 'aprove-button'
}
</script>

<style lang="scss" scoped>
  .disaprove-button {
    padding: 14px 0;
    color: #fff;
    text-align: center;
    border-radius: 50%;
    position: fixed;
    z-index: 10;
    cursor: pointer;
    bottom: 20px;
    right: 36px;
    margin-left: 3px;
    background:#ff4d4d;
    border-color:#fa4444;

    &:hover, &:focus {
      background:#f54040;
    border-color:#e93030;
      color:#fff;
    }
  }

</style>
